import {parseISO} from "date-fns";
import {findInclude} from "api";

function parseEvent(eventData, eventIncluded) {
  const patientTriggerData = findInclude(eventIncluded, "trigger", eventData.relationships.patient_trigger.data.id);

  const result = {
    id: parseInt(eventData.id),
    eventType: eventData.attributes.event_type,
    createdAt: parseISO(eventData.attributes.created_at),
    patientId: eventData.attributes.patient_id,
    customPatientId: eventData.attributes.custom_patient_id,
    name: eventData.attributes.name,
    phone: eventData.attributes.phone,
    patientTriggerEvent: {
      id: parseInt(eventData.relationships.patient_trigger_event.data.id)
    },
    patientTrigger: {
      id: parseInt(patientTriggerData.id),
      threshold: patientTriggerData.attributes.threshold,
      thresholdType: patientTriggerData.attributes.threshold_type,
      description: patientTriggerData.attributes.description,
      priority: patientTriggerData.attributes.priority,
      color: patientTriggerData.attributes.color
    }
  };

  if (eventData.type === "measurement_trigger_event") {
    const measurementData = eventData.attributes.patient_measurement.data;

    result.measurement = {
      id: parseInt(measurementData.id),
      value: measurementData.attributes.value,
      measuredAt: parseISO(measurementData.attributes.measured_at)
    };
    result.patientTrigger.valueType = eventData.attributes.patient_trigger_value_type;
  } else if (eventData.type === "survey_trigger_event") {
    const sessionData = eventData.attributes.patient_survey_session.data;
    result.patientTrigger.surveyName = eventData.attributes.patient_trigger_survey_name;
    result.session = {
      id: parseInt(sessionData.id),
      patientSurveyId: sessionData.attributes.patient_survey_id,
      score: sessionData.attributes.score,
      createdAt: parseISO(sessionData.attributes.created_at)
    };
  }

  return result;
}

export {
  parseEvent
};
